import styled from 'styled-components';

export const Container = styled.div`
  overflow: hidden;
  display: grid;
  grid-template-rows: auto auto auto 1fr;
  .status_template__editor {
    padding: 0;
  }
`;

export const MentionPopup = styled.div`
  position: fixed;
  width: 5px;
  height: 34px;
  z-index: var(--zindex-popover);
  background: transparent;
`;
export const EditorWrapper = styled.div`
  padding: var(--spacing-06);
  overflow-y: scroll;
`;
